import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {environment} from 'src/environments/environment';
import {SearchResponse} from "../models/search";

@Injectable({
  providedIn: 'root'
})
export class SearchTermService {
  term = "";
  constructor(private http: HttpClient) { }

  saveTerm(term: string){
    this.term = term
  }

  getTerm(): string{
    return this.term
  }

  /** SEARCH merchants from the server */
  search(): Observable<SearchResponse> {
    if (this.term.length < 2) {
      return of({
        searchRequest: {
          limit: 30,
          query: this.term,
        },
        locationConfigs: [],
        total: 0
      } as SearchResponse);
    }
    return this.http.get<SearchResponse>(environment.baseUrl + `/api/merchants?q=` + encodeURIComponent(this.term) + `&limit=30`);
  }
}
